import { httpsCallable } from 'firebase/functions';

import { functions } from '../../../firebase.js';

interface GetMeterSummariesParams {
  startTime?: number;
  endTime?: number;
  startISO?: string;
  endISO?: string;
}

export interface MeterEventSummary {
  id: string;
  object: 'billing.meter_event_summary';
  aggregated_value: number;
  end_time: number;
  livemode: boolean;
  meter: string;
  start_time: number;
}

interface MeterData {
  object: 'list';
  data: MeterEventSummary[];
  has_more: boolean;
  url: string;
}

export interface MeterSummaryResult {
  meterId: string;
  data: MeterData;
}

const getMeterSummariesFunction = httpsCallable<
  GetMeterSummariesParams,
  MeterSummaryResult[]
>(functions, 'billingFrontend-getMeterSummaries');

export const getMeterSummaries = async (
  params: GetMeterSummariesParams
): Promise<MeterSummaryResult[]> => {
  const result = await getMeterSummariesFunction(params);
  return result.data;
};
